import * as Yup from 'yup';

export const reviewFormSchema = Yup.object({
  rating: Yup.number().required(''),
  review: Yup.string().required('Review field is required'),
});
